import { ReactElement } from 'react';

import Image from '../UI/Image';
import RichText from '../UI/Richtext';
import CTA from '../UI/Cta';
import { IComponentImageTextOffsetFields, IFragmentCta } from 'types/contentful';

export default function ImageTextOffset({
  body,
  displayType,
  image,
  title,
  cta,
  delimeter,
  backgroundColor,
}: IComponentImageTextOffsetFields): ReactElement {
  const fontColor = backgroundColor === 'Primary' ? 'white' : 'black';
  const defaultView = 'Image Left Text Right';
  const rightImageFlex = displayType === defaultView ? 'lg:flex-row' : 'lg:flex-row-reverse';
  const rightImageXLDisplay = displayType === 'Image Left Text Right' ? 'xl:pr-40' : 'xl:pl-40';
  return (
    <div className="w-full ecp-my">
      <div
        className={`bg-${backgroundColor?.toLowerCase()} text-${fontColor} relative py-6 mt-24 xsm:mt-32 sm:mt-56 lg:py-0 lg:mt-10 `}
      >
        <div
          className={`w-full flex flex-col gap-x-8 justify-around lg:pb-10 lg:pl-24 lg:pr-12 ${rightImageFlex}`}
        >
          <div className="px-10 my-4 -mt-24 xsm:-mt-32 sm:-mt-56 lg:relative lg:px-0 lg:-mt-10 w-full lg:max-w-2xl">
            {image && <Image image={image} query="w=672" classNames="m-auto lg:m-0" />}
          </div>
          <div className={`px-10 sm:px-12 md:px-24 lg:px-6 lg:mx-0 lg:pt-8 lg:w-2/3 `}>
            <div className={`${rightImageXLDisplay}`}>
              <h2 className={`font-heading text-2xl lg:text-3xl text-${fontColor}`}>{title}</h2>
              {body && <RichText document={body} classNames="text-sm lg:text-lg mt-4" />}
              {delimeter != undefined && delimeter && (
                <div className={`border-t-2 w-16 mt-3 border-${fontColor}`}></div>
              )}
            </div>
            <div className="ecp-btn-mt">
              {cta &&
                cta.map((ctaItem: IFragmentCta, i: number) => {
                  return (
                    <CTA
                      key={i}
                      {...ctaItem.fields}
                      classNames="grow mt-6 mr-4 lg:mr-6"
                      backgroundColor={backgroundColor?.toLowerCase() || 'white'}
                    />
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
